module.exports = __webpack_public_path__ + "static/media/IdGED3kke9U.690cec94.png";